import { useState } from "react";

export type IFieldErrors<T extends Object> = {
    [key in keyof T]?: string | Object;
} & { FORM_ERROR?: string; }

type IUseFormErrors<T extends Object> = [
    IFieldErrors<T>,
    (fieldErrors: IFieldErrors<T>) => void
];

export const useFieldErrors = <T extends Object>(): IUseFormErrors<T> => {
    const [fieldErrors, setFieldErrors] = useState<IFieldErrors<T>>({});
    return [
        fieldErrors,
        setFieldErrors
    ];
};
